module.exports = __webpack_public_path__ + "img/nissan-new.96cb475e.png";